import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export enum PermissionAction {
  view = 'view',
  create = 'create',
  edit = 'edit',
  delete = 'delete',
  import = 'import',
  export = 'export',
  markComplete = 'markComplete',
}

export enum AccessLevel {
  fullAccess = 'full_access',
  partialAccess = 'partial_access',
  noAccess = 'no_access',
}

export enum EntityName {
  lead = 'lead',
  activity = 'activity',
  task = 'task',
  workflow = 'workflow',
  report = 'report',
  user = 'user',
  aiCallTrigger = 'aiCallTrigger',
  deal = 'deal',
}

export interface PermissionProperties {
  restrictedFields?: number[];
}

export interface Permission {
  access: AccessLevel;
  properties: PermissionProperties | null;
}

export type EntityPermissions = Partial<Record<PermissionAction, Permission>>;

export type EntityPermissionsType = Partial<Record<EntityName, { permissions?: EntityPermissions }>>;

export interface PermissionsState {
  entityPermissions: EntityPermissionsType;
}

const initialState: PermissionsState = {
  entityPermissions: {},
};

export const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setPermissions: (state, action: PayloadAction<PermissionsState['entityPermissions']>) => {
      state.entityPermissions = action.payload;
    },
  },
});

export const {
  setPermissions,
} = permissionsSlice.actions;

export default permissionsSlice.reducer;
